import { type RootState } from "app";

export const selectProcoreUx = (state: RootState) => state.procoreUx;
export const selectActiveToolMode = (state: RootState) => state.procoreUx.activeToolMode;
